import { Button, CircularProgress, SxProps, Theme } from '@mui/material';

import { MouseEventHandler, ReactNode } from 'react';
import { boxShadow } from '../constants/styles';

export type PrimaryButtonProps = JSX.IntrinsicAttributes & {
  id?: string;
  children?: ReactNode;
  disabled?: boolean;
  endIcon?: ReactNode;
  fullWidth?: boolean;
  href?: string;
  size?: 'small' | 'medium' | 'large';
  startIcon?: ReactNode;
  sx?: SxProps<Theme>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'reset' | 'submit';
  variant?: 'contained' | 'outlined' | 'text';
  loading?: boolean;
  component?: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};

const PrimaryButton = ({ disabled, loading, variant, sx, size, startIcon, ...props }: PrimaryButtonProps) => (
  <Button
    sx={{
      lineHeight: 1.2,
      bgcolor: variant === 'outlined' ? (t) => t.palette.background.paper : undefined,
      boxShadow: 'none',
      borderWidth: variant === 'outlined' ? 1 : undefined,
      height: size === 'small' ? 32 : 40,
      ':hover': {
        borderWidth: 2,
        boxShadow: variant === 'contained' ? boxShadow : undefined,
      },
      ...sx,
    }}
    variant={variant}
    startIcon={startIcon}
    disabled={disabled || loading}
    size={size}
    {...props}
  >
    {loading ? <CircularProgress size={24} /> : props.children}
  </Button>
);

export default PrimaryButton;
